import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface Redirect {
  from_path: string;
  to_path: string;
}

export default function RedirectHandler() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { data: redirects } = useQuery<Redirect[]>({
    queryKey: ["seo-redirects-active"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("seo_redirects")
        .select("from_path, to_path")
        .eq("is_active", true);
      if (error) throw error;
      return data as Redirect[];
    },
    staleTime: 10 * 60 * 1000,
  });

  useEffect(() => {
    if (!redirects) return;
    const match = redirects.find((r) => r.from_path === pathname);
    if (match) {
      navigate(match.to_path, { replace: true });
    }
  }, [pathname, redirects, navigate]);

  return null;
}
